import { UNIFORM_PROPS } from 'common/constants/component-props';

export enum AnswerInputMode {
	Word = 'word',
	Letter = 'letter',
}

export const defaultProps = {
	[UNIFORM_PROPS.answerInputMode]: AnswerInputMode.Word,
};

export const ANSWER_INPUT_MESSAGE_DATA_ATTR = 'message';
export const ANSWER_INPUT_WORDS_DATA_ATTR = 'words';
export const ANSWER_INPUT_LETTERS_DATA_ATTR = 'letters';

export enum AnswerInputBBStateType {
	default = 'default',
	correct = 'correct',
	incorrect = 'incorrect',
	disabled = 'disabled',
}
